/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as ForgotPasswordImport } from './routes/forgot-password'
import { Route as CreateAccountImport } from './routes/create-account'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as AuthSettingsImport } from './routes/_auth/settings'
import { Route as AuthDashboardImport } from './routes/_auth/dashboard'
import { Route as AuthAdminImport } from './routes/_auth/admin'
import { Route as AuthTagBucketIndexImport } from './routes/_auth/tag-bucket/index'
import { Route as AuthSupplyChainIndexImport } from './routes/_auth/supply-chain/index'
import { Route as AuthSireRegistryIndexImport } from './routes/_auth/sire-registry/index'
import { Route as AuthPvpIndexImport } from './routes/_auth/pvp/index'
import { Route as AuthMessagesIndexImport } from './routes/_auth/messages/index'
import { Route as AuthInterventionsIndexImport } from './routes/_auth/interventions/index'
import { Route as AuthConnectedSystemsIndexImport } from './routes/_auth/connected-systems/index'
import { Route as AuthPvpPvpIdImport } from './routes/_auth/pvp/$pvpId'
import { Route as AuthAdminUsersImport } from './routes/_auth/admin/users'
import { Route as AuthAdminPvpIndexImport } from './routes/_auth/admin/pvp/index'
import { Route as PasswordResetConfirmUidTokenImport } from './routes/password-reset.confirm.$uid.$token'
import { Route as AuthAdminPvpPvpIdImport } from './routes/_auth/admin/pvp/$pvpId'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordRoute = ForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const CreateAccountRoute = CreateAccountImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSettingsRoute = AuthSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDashboardRoute = AuthDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAdminRoute = AuthAdminImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)

const AuthTagBucketIndexRoute = AuthTagBucketIndexImport.update({
  id: '/tag-bucket/',
  path: '/tag-bucket/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSupplyChainIndexRoute = AuthSupplyChainIndexImport.update({
  id: '/supply-chain/',
  path: '/supply-chain/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSireRegistryIndexRoute = AuthSireRegistryIndexImport.update({
  id: '/sire-registry/',
  path: '/sire-registry/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPvpIndexRoute = AuthPvpIndexImport.update({
  id: '/pvp/',
  path: '/pvp/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthMessagesIndexRoute = AuthMessagesIndexImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthInterventionsIndexRoute = AuthInterventionsIndexImport.update({
  id: '/interventions/',
  path: '/interventions/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthConnectedSystemsIndexRoute = AuthConnectedSystemsIndexImport.update({
  id: '/connected-systems/',
  path: '/connected-systems/',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPvpPvpIdRoute = AuthPvpPvpIdImport.update({
  id: '/pvp/$pvpId',
  path: '/pvp/$pvpId',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAdminUsersRoute = AuthAdminUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminRoute,
} as any)

const AuthAdminPvpIndexRoute = AuthAdminPvpIndexImport.update({
  id: '/pvp/',
  path: '/pvp/',
  getParentRoute: () => AuthAdminRoute,
} as any)

const PasswordResetConfirmUidTokenRoute =
  PasswordResetConfirmUidTokenImport.update({
    id: '/password-reset/confirm/$uid/$token',
    path: '/password-reset/confirm/$uid/$token',
    getParentRoute: () => rootRoute,
  } as any)

const AuthAdminPvpPvpIdRoute = AuthAdminPvpPvpIdImport.update({
  id: '/pvp/$pvpId',
  path: '/pvp/$pvpId',
  getParentRoute: () => AuthAdminRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/create-account': {
      id: '/create-account'
      path: '/create-account'
      fullPath: '/create-account'
      preLoaderRoute: typeof CreateAccountImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminImport
      parentRoute: typeof AuthImport
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardImport
      parentRoute: typeof AuthImport
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsImport
      parentRoute: typeof AuthImport
    }
    '/_auth/admin/users': {
      id: '/_auth/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminUsersImport
      parentRoute: typeof AuthAdminImport
    }
    '/_auth/pvp/$pvpId': {
      id: '/_auth/pvp/$pvpId'
      path: '/pvp/$pvpId'
      fullPath: '/pvp/$pvpId'
      preLoaderRoute: typeof AuthPvpPvpIdImport
      parentRoute: typeof AuthImport
    }
    '/_auth/connected-systems/': {
      id: '/_auth/connected-systems/'
      path: '/connected-systems'
      fullPath: '/connected-systems'
      preLoaderRoute: typeof AuthConnectedSystemsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/interventions/': {
      id: '/_auth/interventions/'
      path: '/interventions'
      fullPath: '/interventions'
      preLoaderRoute: typeof AuthInterventionsIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/messages/': {
      id: '/_auth/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthMessagesIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/pvp/': {
      id: '/_auth/pvp/'
      path: '/pvp'
      fullPath: '/pvp'
      preLoaderRoute: typeof AuthPvpIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sire-registry/': {
      id: '/_auth/sire-registry/'
      path: '/sire-registry'
      fullPath: '/sire-registry'
      preLoaderRoute: typeof AuthSireRegistryIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/supply-chain/': {
      id: '/_auth/supply-chain/'
      path: '/supply-chain'
      fullPath: '/supply-chain'
      preLoaderRoute: typeof AuthSupplyChainIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/tag-bucket/': {
      id: '/_auth/tag-bucket/'
      path: '/tag-bucket'
      fullPath: '/tag-bucket'
      preLoaderRoute: typeof AuthTagBucketIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/admin/pvp/$pvpId': {
      id: '/_auth/admin/pvp/$pvpId'
      path: '/pvp/$pvpId'
      fullPath: '/admin/pvp/$pvpId'
      preLoaderRoute: typeof AuthAdminPvpPvpIdImport
      parentRoute: typeof AuthAdminImport
    }
    '/password-reset/confirm/$uid/$token': {
      id: '/password-reset/confirm/$uid/$token'
      path: '/password-reset/confirm/$uid/$token'
      fullPath: '/password-reset/confirm/$uid/$token'
      preLoaderRoute: typeof PasswordResetConfirmUidTokenImport
      parentRoute: typeof rootRoute
    }
    '/_auth/admin/pvp/': {
      id: '/_auth/admin/pvp/'
      path: '/pvp'
      fullPath: '/admin/pvp'
      preLoaderRoute: typeof AuthAdminPvpIndexImport
      parentRoute: typeof AuthAdminImport
    }
  }
}

// Create and export the route tree

interface AuthAdminRouteChildren {
  AuthAdminUsersRoute: typeof AuthAdminUsersRoute
  AuthAdminPvpPvpIdRoute: typeof AuthAdminPvpPvpIdRoute
  AuthAdminPvpIndexRoute: typeof AuthAdminPvpIndexRoute
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminUsersRoute: AuthAdminUsersRoute,
  AuthAdminPvpPvpIdRoute: AuthAdminPvpPvpIdRoute,
  AuthAdminPvpIndexRoute: AuthAdminPvpIndexRoute,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthPvpPvpIdRoute: typeof AuthPvpPvpIdRoute
  AuthConnectedSystemsIndexRoute: typeof AuthConnectedSystemsIndexRoute
  AuthInterventionsIndexRoute: typeof AuthInterventionsIndexRoute
  AuthMessagesIndexRoute: typeof AuthMessagesIndexRoute
  AuthPvpIndexRoute: typeof AuthPvpIndexRoute
  AuthSireRegistryIndexRoute: typeof AuthSireRegistryIndexRoute
  AuthSupplyChainIndexRoute: typeof AuthSupplyChainIndexRoute
  AuthTagBucketIndexRoute: typeof AuthTagBucketIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthPvpPvpIdRoute: AuthPvpPvpIdRoute,
  AuthConnectedSystemsIndexRoute: AuthConnectedSystemsIndexRoute,
  AuthInterventionsIndexRoute: AuthInterventionsIndexRoute,
  AuthMessagesIndexRoute: AuthMessagesIndexRoute,
  AuthPvpIndexRoute: AuthPvpIndexRoute,
  AuthSireRegistryIndexRoute: AuthSireRegistryIndexRoute,
  AuthSupplyChainIndexRoute: AuthSupplyChainIndexRoute,
  AuthTagBucketIndexRoute: AuthTagBucketIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/create-account': typeof CreateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/settings': typeof AuthSettingsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/pvp/$pvpId': typeof AuthPvpPvpIdRoute
  '/connected-systems': typeof AuthConnectedSystemsIndexRoute
  '/interventions': typeof AuthInterventionsIndexRoute
  '/messages': typeof AuthMessagesIndexRoute
  '/pvp': typeof AuthPvpIndexRoute
  '/sire-registry': typeof AuthSireRegistryIndexRoute
  '/supply-chain': typeof AuthSupplyChainIndexRoute
  '/tag-bucket': typeof AuthTagBucketIndexRoute
  '/admin/pvp/$pvpId': typeof AuthAdminPvpPvpIdRoute
  '/password-reset/confirm/$uid/$token': typeof PasswordResetConfirmUidTokenRoute
  '/admin/pvp': typeof AuthAdminPvpIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/create-account': typeof CreateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/settings': typeof AuthSettingsRoute
  '/admin/users': typeof AuthAdminUsersRoute
  '/pvp/$pvpId': typeof AuthPvpPvpIdRoute
  '/connected-systems': typeof AuthConnectedSystemsIndexRoute
  '/interventions': typeof AuthInterventionsIndexRoute
  '/messages': typeof AuthMessagesIndexRoute
  '/pvp': typeof AuthPvpIndexRoute
  '/sire-registry': typeof AuthSireRegistryIndexRoute
  '/supply-chain': typeof AuthSupplyChainIndexRoute
  '/tag-bucket': typeof AuthTagBucketIndexRoute
  '/admin/pvp/$pvpId': typeof AuthAdminPvpPvpIdRoute
  '/password-reset/confirm/$uid/$token': typeof PasswordResetConfirmUidTokenRoute
  '/admin/pvp': typeof AuthAdminPvpIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/create-account': typeof CreateAccountRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/admin/users': typeof AuthAdminUsersRoute
  '/_auth/pvp/$pvpId': typeof AuthPvpPvpIdRoute
  '/_auth/connected-systems/': typeof AuthConnectedSystemsIndexRoute
  '/_auth/interventions/': typeof AuthInterventionsIndexRoute
  '/_auth/messages/': typeof AuthMessagesIndexRoute
  '/_auth/pvp/': typeof AuthPvpIndexRoute
  '/_auth/sire-registry/': typeof AuthSireRegistryIndexRoute
  '/_auth/supply-chain/': typeof AuthSupplyChainIndexRoute
  '/_auth/tag-bucket/': typeof AuthTagBucketIndexRoute
  '/_auth/admin/pvp/$pvpId': typeof AuthAdminPvpPvpIdRoute
  '/password-reset/confirm/$uid/$token': typeof PasswordResetConfirmUidTokenRoute
  '/_auth/admin/pvp/': typeof AuthAdminPvpIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/create-account'
    | '/forgot-password'
    | '/login'
    | '/admin'
    | '/dashboard'
    | '/settings'
    | '/admin/users'
    | '/pvp/$pvpId'
    | '/connected-systems'
    | '/interventions'
    | '/messages'
    | '/pvp'
    | '/sire-registry'
    | '/supply-chain'
    | '/tag-bucket'
    | '/admin/pvp/$pvpId'
    | '/password-reset/confirm/$uid/$token'
    | '/admin/pvp'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/create-account'
    | '/forgot-password'
    | '/login'
    | '/admin'
    | '/dashboard'
    | '/settings'
    | '/admin/users'
    | '/pvp/$pvpId'
    | '/connected-systems'
    | '/interventions'
    | '/messages'
    | '/pvp'
    | '/sire-registry'
    | '/supply-chain'
    | '/tag-bucket'
    | '/admin/pvp/$pvpId'
    | '/password-reset/confirm/$uid/$token'
    | '/admin/pvp'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/create-account'
    | '/forgot-password'
    | '/login'
    | '/_auth/admin'
    | '/_auth/dashboard'
    | '/_auth/settings'
    | '/_auth/admin/users'
    | '/_auth/pvp/$pvpId'
    | '/_auth/connected-systems/'
    | '/_auth/interventions/'
    | '/_auth/messages/'
    | '/_auth/pvp/'
    | '/_auth/sire-registry/'
    | '/_auth/supply-chain/'
    | '/_auth/tag-bucket/'
    | '/_auth/admin/pvp/$pvpId'
    | '/password-reset/confirm/$uid/$token'
    | '/_auth/admin/pvp/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  CreateAccountRoute: typeof CreateAccountRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PasswordResetConfirmUidTokenRoute: typeof PasswordResetConfirmUidTokenRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  CreateAccountRoute: CreateAccountRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PasswordResetConfirmUidTokenRoute: PasswordResetConfirmUidTokenRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/create-account",
        "/forgot-password",
        "/login",
        "/password-reset/confirm/$uid/$token"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/admin",
        "/_auth/dashboard",
        "/_auth/settings",
        "/_auth/pvp/$pvpId",
        "/_auth/connected-systems/",
        "/_auth/interventions/",
        "/_auth/messages/",
        "/_auth/pvp/",
        "/_auth/sire-registry/",
        "/_auth/supply-chain/",
        "/_auth/tag-bucket/"
      ]
    },
    "/create-account": {
      "filePath": "create-account.tsx"
    },
    "/forgot-password": {
      "filePath": "forgot-password.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_auth/admin": {
      "filePath": "_auth/admin.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/admin/users",
        "/_auth/admin/pvp/$pvpId",
        "/_auth/admin/pvp/"
      ]
    },
    "/_auth/dashboard": {
      "filePath": "_auth/dashboard.tsx",
      "parent": "/_auth"
    },
    "/_auth/settings": {
      "filePath": "_auth/settings.tsx",
      "parent": "/_auth"
    },
    "/_auth/admin/users": {
      "filePath": "_auth/admin/users.tsx",
      "parent": "/_auth/admin"
    },
    "/_auth/pvp/$pvpId": {
      "filePath": "_auth/pvp/$pvpId.tsx",
      "parent": "/_auth"
    },
    "/_auth/connected-systems/": {
      "filePath": "_auth/connected-systems/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/interventions/": {
      "filePath": "_auth/interventions/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/messages/": {
      "filePath": "_auth/messages/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/pvp/": {
      "filePath": "_auth/pvp/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/sire-registry/": {
      "filePath": "_auth/sire-registry/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/supply-chain/": {
      "filePath": "_auth/supply-chain/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/tag-bucket/": {
      "filePath": "_auth/tag-bucket/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/admin/pvp/$pvpId": {
      "filePath": "_auth/admin/pvp/$pvpId.tsx",
      "parent": "/_auth/admin"
    },
    "/password-reset/confirm/$uid/$token": {
      "filePath": "password-reset.confirm.$uid.$token.tsx"
    },
    "/_auth/admin/pvp/": {
      "filePath": "_auth/admin/pvp/index.tsx",
      "parent": "/_auth/admin"
    }
  }
}
ROUTE_MANIFEST_END */
